'use strict';

var $order = $('.header-account-item.header-item-order');
var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');

var OrderProgress = {
  getOrder: function getOrder() {
    if (!$order.length || !$order.hasClass('header-order-item')) {
      $order.removeClass('js-menu-item-with-sub');
      return false;
    }

    HTTPService.get('/api/htmls/order/last/?header=true&pageName=' + blz.pageName)
      .then(HTTPService.handleClientError)
      .then(function (data) {
        if (data) {
          $order[0].innerHTML = data;
        }
      })
      .catch(NotificationService.warning);
  }
};

OrderProgress.getOrder();
module.exports = OrderProgress;
